<template>
  <div class="menu-page">
    <v-alert prominent color="primary" text icon="mdi-school-outline">
      <v-row align="center">
        <v-col cols="12" lg="8" md="8" sm="8" class="grow">
          Quer entender qual o melhor tipo de chatbot para fazer o primeiro atendimento? Assista nossos vídeos
          para usufruir do que há de melhor em automação.
        </v-col>
        <v-col cols="12" lg="4" md="4" sm="4" class="d-flex" @click="$router.push('/ajuda')">
          <v-spacer></v-spacer>
          <ib-btn class="primary">Ver vídeos</ib-btn>
        </v-col>
      </v-row>
    </v-alert>

    <v-card class="nd-border" flat>
      <v-card-title>
        Meus chips - Conectar chip
      </v-card-title>

      <v-card-subtitle>
        Conecte aqui seus números de Whatsapp para receber e enviar mensagens. <ib-btn small @click="showVideo = true"><v-icon size="16" class="mr-1">mdi-help-circle-outline</v-icon>Saiba mais</ib-btn>
      </v-card-subtitle>

      <v-card-text>
        <v-row>
          <v-col cols="12" class="d-flex flex-wrap justify-end">
            <v-spacer></v-spacer>
            <ib-btn color="primary" class="mt-2" @click.native="selectedItem = { official: false, create_opportunity: false, inactivity_config: { enabled: false, time: 30, time_unit: 'minutes', context: [], action: null, flow: null, department: null } }; dialogChip = true">
              <v-icon>mdi-plus</v-icon>Novo chip
            </ib-btn>

            <ib-btn color="primary" class="ml-2 mt-2" @click.native="selectedItem = { official: true, create_opportunity: false, inactivity_config: { enabled: false, time: 30, time_unit: 'minutes', context: [], action: null, flow: null, department: null } }; dialogChip = true">
              <v-icon>mdi-plus</v-icon>Novo número (API Oficial)
            </ib-btn>
          </v-col>
        </v-row>
      </v-card-text>


      <v-card-text>
        <v-data-table :headers="headers" :items="chip_numbers" :loading="loading">
          <template #[`item.name`]="{ item }">
            <div class="d-flex align-center py-2">
              <div>
                {{ item.override_name || item.name }}
              </div>
            </div>
          </template>

          <template #[`item.official`]="{ item }">
            <ib-chip small class="my-1 mr-1" :color="item.official ? $vuetify.theme.themes.light.primary : $vuetify.theme.themes.light.info">
              {{ item.official ? 'API Oficial' : 'Conexão direta' }}
            </ib-chip>
          </template>

          <template #[`item.redirect`]="{ item }">
            <v-icon small left color="primary">
              {{ getDestinationName(item)?.icon }}
            </v-icon>
            {{ getDestinationName(item)?.name }}
          </template>

          <template #[`item.department`]="{ item }">
            {{ getDepartmentName(item.department) }}
          </template>

          <template #[`item.display_phone_number`]="{ item }">
            {{ item.display_phone_number }}
          </template>

          <template #[`item.phone_number_quality`]="{ item }">
            <v-avatar size="16" :color="$ratingColor(item.phone_number_quality)" />
          </template>

          <template #[`item.status`]="{ item }">
            <ib-chip v-if="item.status === 'open'" small class="my-1 mr-1 " :color="$vuetify.theme.themes.light.primary">
              Conectado
            </ib-chip>
            <ib-chip v-else small class="my-1 mr-1" :color="$vuetify.theme.themes.light.error">
              {{ connection_statuses[item.status] }}
            </ib-chip>
          </template>

          <template #[`item.actions`]="{ item }">
            <v-menu>
              <template #activator="{ on, attrs }">
                <ib-btn icon v-bind="attrs" v-on="on">
                  <v-icon>mdi-dots-horizontal</v-icon>
                </ib-btn>
              </template>

              <v-card>
                <v-list-item @click="editChip(item)">
                  <v-list-item-icon>
                    <v-icon>mdi-file-edit-outline</v-icon>
                  </v-list-item-icon>

                  <v-list-item-content>
                    <v-list-item-title>Configurar</v-list-item-title>
                  </v-list-item-content>
                </v-list-item>


                <v-list-item @click="disconnectChip(item)">
                  <v-list-item-icon>
                    <v-icon>mdi-cellphone-remove</v-icon>
                  </v-list-item-icon>

                  <v-list-item-content>
                    <v-list-item-title>Desconectar número</v-list-item-title>
                  </v-list-item-content>
                </v-list-item>


                <v-list-item v-if="item.official != true" @click="selectedItem = item; dialog = true">
                  <v-list-item-icon>
                    <v-icon>mdi-cellphone-off</v-icon>
                  </v-list-item-icon>

                  <v-list-item-content>
                    <v-list-item-title>Resetar conexão</v-list-item-title>
                  </v-list-item-content>
                </v-list-item>

                <v-list-item v-if="!item.changed && item.status != 'open' && !item.qrcode" @click="connectChip(item)">
                  <v-list-item-icon>
                    <v-icon>mdi-cellphone-check</v-icon>
                  </v-list-item-icon>

                  <v-list-item-content>
                    <v-list-item-title>Conectar</v-list-item-title>
                  </v-list-item-content>
                </v-list-item>
              </v-card>
            </v-menu>
          </template>
        </v-data-table>
      </v-card-text>
    </v-card>

    <ib-dialog v-model="dialogQrCode" scrollable max-width="600" persistent>
      <v-card light color="white">
        <ib-dialog-header title="Conectar Whatsapp" subtitle="Siga as instruções abaixo para conectar seu Whatsapp" :close="() => { qrcode_chip = {}; dialogQrCode = false }"></ib-dialog-header>

        <v-card-text v-if="qrcode_chip.qrcode && qrcode_chip.status != 'open'" class="mt-4">
          <div>1. Abra o Whatsapp no seu celular</div>
          <div>
            2. Toque no ícone
            <svg class="mx-1" height="24px" viewBox="0 0 24 24" width="24px">
              <rect fill="#f2f2f2" height="24" rx="3" width="24" />
              <path d="m12 15.5c.825 0 1.5.675 1.5 1.5s-.675 1.5-1.5 1.5-1.5-.675-1.5-1.5.675-1.5 1.5-1.5zm0-2c-.825 0-1.5-.675-1.5-1.5s.675-1.5 1.5-1.5 1.5.675 1.5 1.5-.675 1.5-1.5 1.5zm0-5c-.825 0-1.5-.675-1.5-1.5s.675-1.5 1.5-1.5 1.5.675 1.5 1.5-.675 1.5-1.5 1.5z" fill="#818b90" />
            </svg>
            no Android ou em
            <svg class="mx-1" width="24" height="24" viewBox="0 0 24 24">
              <rect fill="#F2F2F2" width="24" height="24" rx="3" />
              <path d="M12 18.69c-1.08 0-2.1-.25-2.99-.71L11.43 14c.24.06.4.08.56.08.92 0 1.67-.59 1.99-1.59h4.62c-.26 3.49-3.05 6.2-6.6 6.2zm-1.04-6.67c0-.57.48-1.02 1.03-1.02.57 0 1.05.45 1.05 1.02 0 .57-.47 1.03-1.05 1.03-.54.01-1.03-.46-1.03-1.03zM5.4 12c0-2.29 1.08-4.28 2.78-5.49l2.39 4.08c-.42.42-.64.91-.64 1.44 0 .52.21 1 .65 1.44l-2.44 4C6.47 16.26 5.4 14.27 5.4 12zm8.57-.49c-.33-.97-1.08-1.54-1.99-1.54-.16 0-.32.02-.57.08L9.04 5.99c.89-.44 1.89-.69 2.96-.69 3.56 0 6.36 2.72 6.59 6.21h-4.62zM12 19.8c.22 0 .42-.02.65-.04l.44.84c.08.18.25.27.47.24.21-.03.33-.17.36-.38l.14-.93c.41-.11.82-.27 1.21-.44l.69.61c.15.15.33.17.54.07.17-.1.24-.27.2-.48l-.2-.92c.35-.24.69-.52.99-.82l.86.36c.2.08.37.05.53-.14.14-.15.15-.34.03-.52l-.5-.8c.25-.35.45-.73.63-1.12l.95.05c.21.01.37-.09.44-.29.07-.2.01-.38-.16-.51l-.73-.58c.1-.4.19-.83.22-1.27l.89-.28c.2-.07.31-.22.31-.43s-.11-.35-.31-.42l-.89-.28c-.03-.44-.12-.86-.22-1.27l.73-.59c.16-.12.22-.29.16-.5-.07-.2-.23-.31-.44-.29l-.95.04c-.18-.4-.39-.77-.63-1.12l.5-.8c.12-.17.1-.36-.03-.51-.16-.18-.33-.22-.53-.14l-.86.35c-.31-.3-.65-.58-.99-.82l.2-.91c.03-.22-.03-.4-.2-.49-.18-.1-.34-.09-.48.01l-.74.66c-.39-.18-.8-.32-1.21-.43l-.14-.93a.426.426 0 00-.36-.39c-.22-.03-.39.05-.47.22l-.44.84-.43-.02h-.22c-.22 0-.42.01-.65.03l-.44-.84c-.08-.17-.25-.25-.48-.22-.2.03-.33.17-.36.39l-.13.88c-.42.12-.83.26-1.22.44l-.69-.61c-.15-.15-.33-.17-.53-.06-.18.09-.24.26-.2.49l.2.91c-.36.24-.7.52-1 .82l-.86-.35c-.19-.09-.37-.05-.52.13-.14.15-.16.34-.04.51l.5.8c-.25.35-.45.72-.64 1.12l-.94-.04c-.21-.01-.37.1-.44.3-.07.2-.02.38.16.5l.73.59c-.1.41-.19.83-.22 1.27l-.89.29c-.21.07-.31.21-.31.42 0 .22.1.36.31.43l.89.28c.03.44.1.87.22 1.27l-.73.58c-.17.12-.22.31-.16.51.07.2.23.31.44.29l.94-.05c.18.39.39.77.63 1.12l-.5.8c-.12.18-.1.37.04.52.16.18.33.22.52.14l.86-.36c.3.31.64.58.99.82l-.2.92c-.04.22.03.39.2.49.2.1.38.08.54-.07l.69-.61c.39.17.8.33 1.21.44l.13.93c.03.21.16.35.37.39.22.03.39-.06.47-.24l.44-.84c.23.02.44.04.66.04z" fill="#818b90" />
            </svg>
            no iPhone
          </div>
          <div>
            3. Toque em <b>Dispositivos conectados</b> e, em seguida, em <b>Conectar um dispositivo</b>
          </div>
          <div>4. Aponte seu celular para esta tela para capturar o QR code</div>
        </v-card-text>

        <v-card-text v-if="qrcode_chip.qrcode && qrcode_chip.status != 'open'" class="py-6 d-flex justify-center" >
          <qrcode-vue :value="qrcode_chip.qrcode" size="260" level="M" />
        </v-card-text>
      </v-card>
    </ib-dialog>

    <ib-dialog v-model="dialogChip" scrollable max-width="650" persistent>
      <v-card>
        <ib-dialog-header :subtitle="selectedItem.official ? 'Após salvar, vamos te guiar na conexão com a Meta.' : 'Na primeira configuração, é necessário conectá-lo assim como se conecta um número ao Whatsapp Web.'" title="Whatsapp" :close="() => { dialogChip = false }"></ib-dialog-header>

        <v-card-text>
          <v-row>
            <v-col cols="12">
              <ib-text-field v-model="selectedItem.name" class="pt-1" label="Nome do canal" outlined color="primary" hide-details="auto" @keyup="formatText" />
            </v-col>
            <v-col cols="12" lg="6" md="6" sm="12">
              <ib-select v-model="selectedItem.redirect" chips class="pt-1" mandatory small-chips item-text="name" item-value="id" :items="redirects" label="Primeiro atendimento" color="primary" outlined hide-details="auto" />
            </v-col>
            <v-col v-if="selectedItem.redirect == 'ai_chatbot'" cols="12" lg="6" md="6" sm="12">
              <ib-select v-model="selectedItem.chatbot" class="pt-1" chips small-chips clearable item-text="name" item-value="_id" :items="chatbots" label="Chatbot" color="primary" outlined hide-details="auto" />
            </v-col>
            <v-col v-if="selectedItem.redirect == 'flow_chatbot'" cols="12" lg="6" md="6" sm="12">
              <ib-select v-model="selectedItem.flow" class="pt-1" chips small-chips clearable item-text="name" item-value="_id" :items="flows" label="Fluxo" color="primary" outlined hide-details="auto" />
            </v-col>
            <v-col cols="12" lg="6" md="6" sm="12">
              <ib-select v-model="selectedItem.department" class="pt-1" chips small-chips clearable item-text="name" item-value="_id" :items="departments" label="Departamento padrão" color="primary" outlined hide-details="auto" />
            </v-col>

            <v-col cols="12">
              <div class="d-flex align-center">
                <v-switch v-model="selectedItem.create_opportunity" class="mt-0 pt-0" color="primary" hide-details inset>
                  <template #label>
                    <span class="text-body-2">Criar oportunidade no Kanban automaticamente</span>
                  </template>
                </v-switch>
              </div>
            </v-col>

            <v-col v-if="selectedItem.create_opportunity" cols="12" lg="6" md="6" sm="12">
              <ib-select v-model="selectedItem.funnel" class="pt-1" chips small-chips item-text="name" item-value="_id" :items="funnels" label="Funil" color="primary" outlined hide-details="auto" @change="onFunnelChange" />
            </v-col>

            <v-col v-if="selectedItem.create_opportunity && selectedItem.funnel" cols="12" lg="6" md="6" sm="12">
              <ib-select v-model="selectedItem.funnel_step" class="pt-1" chips small-chips item-text="title" item-value="_id" :items="funnelSteps" label="Etapa do funil" color="primary" outlined hide-details="auto" />
            </v-col>

            <v-col cols="12">
              <v-divider class="my-2"></v-divider>
            </v-col>

            <v-col v-if="selectedItem.inactivity_config" cols="12">
              <div class="d-flex align-center">
                <v-switch v-model="selectedItem.inactivity_config.enabled" class="mt-0 pt-0" color="primary" hide-details inset>
                  <template #label>
                    <span class="text-body-2">Ativar ações de inatividade</span>
                  </template>
                </v-switch>
              </div>
            </v-col>

            <v-col v-if="selectedItem.inactivity_config && selectedItem.inactivity_config.enabled" cols="12">
              <ib-select v-model="selectedItem.inactivity_config.context" class="pt-1" chips small-chips multiple item-text="name" item-value="id" :items="redirects" label="Contexto da inatividade" color="primary" hide-details="auto" />
            </v-col>

            <v-col v-if="selectedItem.inactivity_config && selectedItem.inactivity_config.enabled" cols="12" sm="6">
              <ib-select v-model="selectedItem.inactivity_config.time_unit" class="pt-1" chips small-chips item-text="name" item-value="id" :items="timeUnits" label="Unidade" color="primary" hide-details="auto" />
            </v-col>

            <v-col v-if="selectedItem.inactivity_config && selectedItem.inactivity_config.enabled" cols="12" sm="6">
              <ib-text-field v-model.number="selectedItem.inactivity_config.time" class="pt-1" label="Tempo de inatividade" outlined color="primary" hide-details="auto" type="number" min="1" />
            </v-col>

            <v-col v-if="selectedItem.inactivity_config && selectedItem.inactivity_config.enabled" cols="12" sm="6">
              <ib-select v-model="selectedItem.inactivity_config.action" class="pt-1" chips small-chips item-text="name" item-value="id" :items="inactivityActions" label="Ação de inatividade" color="primary" hide-details="auto" />
            </v-col>

            <v-col v-if="selectedItem.inactivity_config && selectedItem.inactivity_config.enabled && selectedItem.inactivity_config.action === 'flow_chatbot'" cols="12" sm="6">
              <ib-select v-model="selectedItem.inactivity_config.flow" class="pt-1" chips small-chips item-text="name" item-value="_id" :items="flows" label="Fluxo de inatividade" color="primary" hide-details="auto" />
            </v-col>

            <v-col v-if="selectedItem.inactivity_config && selectedItem.inactivity_config.enabled && selectedItem.inactivity_config.action === 'human'" cols="12" sm="6">
              <ib-select v-model="selectedItem.inactivity_config.department" class="pt-1" chips small-chips item-text="name" item-value="_id" :items="departments" label="Departamento de inatividade" color="primary" hide-details="auto" />
            </v-col>
          </v-row>
        </v-card-text>

        <v-card-actions>
          <ib-btn color="gray200" outlined @click.native="dialogChip = false">
            <div class="gray1000--text">
              Cancelar
            </div>
          </ib-btn>
          <v-spacer />
          <ib-btn color="primary" :loading="loading" @click.native="createOrUpdate()">
            Salvar
          </ib-btn>
        </v-card-actions>
      </v-card>
    </ib-dialog>

    <ib-dialog v-model="dialogConfig" scrollable max-width="760" persistent>
      <v-card>
        <ib-dialog-header title="Conectar à API Oficial do WhatsApp" subtitle="Escolha como você quer conectar este número" :close="() => { dialogConfig = false }"></ib-dialog-header>

        <v-card-text>
          <v-row>
            <v-col cols="12" md="6">
              <div class="connection-option" role="button" tabindex="0" @click="goToSignup('ApiOficial')" @keyup.enter="goToSignup('ApiOficial')">
                <div class="d-flex align-center">
                  <v-avatar size="40" color="green50" rounded class="mr-3">
                    <v-icon color="primary">mdi-cloud-check-outline</v-icon>
                  </v-avatar>
                  <div class="connection-option-title">API Oficial</div>
                </div>
                <div class="connection-option-subtitle primary--text mt-2">Para número novo ou dedicado ao atendimento</div>
                <ul class="text-body-2 mt-2 pl-4">
                  <li>O número passa a funcionar só pela InteligênciaBot.</li>
                  <li>Você escolhe o portfólio (BM) e a conta do WhatsApp e confirma o número por SMS ou ligação.</li>
                </ul>
                <div class="connection-option-requirement text-caption">
                  <b>Requisito:</b> o número não pode estar ativo em nenhum WhatsApp.
                </div>
              </div>
            </v-col>

            <v-col cols="12" md="6">
              <div class="connection-option" role="button" tabindex="0" @click="goToSignup('Coex')" @keyup.enter="goToSignup('Coex')">
                <div class="d-flex align-center">
                  <v-avatar size="40" color="green50" rounded class="mr-3">
                    <v-icon color="primary">mdi-cellphone-link</v-icon>
                  </v-avatar>
                  <div class="connection-option-title">Coexistência (Coex)</div>
                </div>
                <div class="connection-option-subtitle primary--text mt-2">Para quem já atende pelo app</div>
                <ul class="text-body-2 mt-2 pl-4">
                  <li>Use o mesmo número no WhatsApp Business do celular e na InteligênciaBot ao mesmo tempo.</li>
                  <li>Algumas funções do app ficam limitadas.</li>
                </ul>
                <div class="connection-option-requirement text-caption">
                  <b>Requisito:</b> número ativo no WhatsApp Business app, versão 2.24.17 ou superior.
                </div>
              </div>
            </v-col>

            <v-col cols="12" class="pt-0">
              <div class="text-body-2">
                Já usa este número no WhatsApp Business do celular e quer continuar usando? Escolha <b>Coexistência</b>.
              </div>
            </v-col>
          </v-row>
        </v-card-text>

        <v-card-actions>

          <ib-btn color="gray200" outlined @click.native="dialogConfig = false">
            <div class="gray1000--text">
              Cancelar
            </div>
          </ib-btn>
          <v-spacer />
          <ib-btn text color="primary" @click.native="callSupport">
            <v-icon left>mdi-face-agent</v-icon>Prefiro falar com o suporte
          </ib-btn>
        </v-card-actions>
      </v-card>
    </ib-dialog>


    <ib-dialog v-model="dialog" overlay-opacity="0.5" overlay-color="black" max-width="420">
      <v-card>
        <ib-dialog-header title="Resetar conexão" subtitle="Pode resolver problemas de conexão, mas será necessário conectar com QRCode novamente." :close="() => { dialog = false }"></ib-dialog-header>

        <v-card-text>
          Tem certeza que deseja apagar as credenciais do canal <b>{{ selectedItem.name }}</b>? Para
          conectar novamente será necessária a leitura do QRCode.
        </v-card-text>
        <v-card-actions>

          <ib-btn color="gray200" outlined @click="dialog = false">
            <div class="gray1000--text">
              Cancelar
            </div>
          </ib-btn>
          <v-spacer />
          <ib-btn color="error" @click="dialog = false; resetCreds(selectedItem)">
            Resetar
          </ib-btn>
        </v-card-actions>
      </v-card>
    </ib-dialog>

    <video-dialog v-model="showVideo" videoUrl="https://www.youtube.com/embed/F-wiQbFw2l4?rel=0" />
  </div>
</template>

<script>
import Api from "@/lib/Api";
import { emitToastr } from "@/lib/Utils";
import QrcodeVue from "qrcode.vue";
import VideoDialog from "@/components/VideoDialog.vue";

let socket;
let socket_connection_count = 0;

export default {
  name: "ChipNumbersView",

  components: {
    QrcodeVue,
    VideoDialog
  },

  data() {
    return {
      showVideo: false,
      chip_numbers: [],
      selectedItem: { 
        redirect: 'ai_chatbot', 
        create_opportunity: false, 
        inactivity_config: {
          enabled: false, 
          time: 30, 
          time_unit: 'minutes', 
          context: [], 
          action: null, 
          flow: null, 
          department: null 
        }
      },
      qrcode_chip: {},
      chatbots: [],
      departments: [],
      flows: [],
      funnels: [],
      funnelSteps: [],
      redirects: [{ name: 'Chatbot de IA', id: 'ai_chatbot' }, { name: 'Chatbot de Fluxo', id: 'flow_chatbot' }, { name: 'Atendimento humano', id: 'human' }],
      inactivityActions: [{ name: 'Transferir para fluxo', id: 'flow_chatbot' },{ name: 'Transferir para humano', id: 'human' }, { name : 'Finalizar conversa', id: 'finish_conversation' }],
      timeUnits: [{ name: 'Minutos', id: 'minutes' }, { name: 'Horas', id: 'hours' }],
      loading: false,
      dialog: false,
      dialogChip: false,
      dialogQrCode: false,
      dialogConfig: false,
      configChipId: null,
      connection_statuses: {
        "close": "Desconectado",
        "new": "Desconectado",
        "open": "Conectado",
        "connecting": "Conectando",
        "configuring": "Configurar",
        "unavailable": "Indisponível",
      },
      headers: [
        { text: 'Nome', value: 'name', sortable: false, },
        { text: 'Tipo', value: 'official', sortable: false, },
        { text: 'Status', value: 'status', sortable: false, },
        { text: 'Telefone', value: 'display_phone_number', sortable: false, },
        { text: 'Qualidade', value: 'phone_number_quality', sortable: false, },
        { text: 'Atendimento', value: 'redirect', sortable: false, },
        { text: 'Departamento', value: 'department', sortable: false, },
        { text: 'Ações', icon: "mdi-menu", value: 'actions', sortable: false, width: 50 },
      ]
    };
  },
  computed: {
    currentUser() {
      return this.$store.state.currentUser;
    },
  },

  mounted() {
    this.getChips();
    this.getChatsbots();
    this.getDepartments();
    this.getFlows();
    this.getFunnels();
    this.startSocket();
  },

  async beforeDestroy() {
    socket.disconnect();
    socket = null;
  },

  methods: {
    async getChips() {
      const resp = await Api.getChipNumbersByUser();

      if (!resp.error && resp.message) {
        this.chip_numbers = resp.message;
      }
    },

    async getChatsbots() {
      const resp = await Api.getChatbotsByUser();

      if (!resp.error && resp.message) {
        this.chatbots = resp.message;
      }
    },

    async getDepartments() {
      const resp = await Api.getDepartmentsByUser();

      if (!resp.error && resp.message) {
        this.departments = resp.message;
      }
    },

    async getFlows() {
      const resp = await Api.getFlowsByUser();

      if (!resp.error && resp.message) {
        this.flows = resp.message;
      }
    },

    async getFunnels() {
      const resp = await Api.getFunnelsByAccount();

      if (!resp.error && resp.message) {
        this.funnels = resp.message || [];
      }
    },

    async onFunnelChange() {
      this.selectedItem.funnel_step = null;
      this.funnelSteps = [];

      if (!this.selectedItem.funnel) return;

      const resp = await Api.getFullFunnelById(this.selectedItem.funnel);
      
      if (!resp.error && resp.message) {
        this.funnelSteps = resp.message.steps || [];
      }
    },

    startSocket() {
      if (socket_connection_count >= 3) {
        emitToastr("error", "Erro na conexão com o socket. Atualize a página para tentar novamente.");
        return;
      }

      if (!this.$store.state.SOCKET_IO_URL) {
        socket_connection_count++
        setTimeout(() => { this.startSocket(); }, 500 + socket_connection_count * 2000);
        emitToastr("info", "Aguardando endereço do socket...");
        return;
      }

      socket_connection_count = 0;
      socket = this.$io(this.$store.state.SOCKET_IO_URL, { path: '/sock/' });

      socket.on("connect", () => {
        socket.emit("join-room", this.currentUser?.account?._id);
      });


      socket.on("receive-message", data => {
        if (data?.type == 'qrcode') {
          if (data.chip_number_id && data.message) this.updateQrcode(data.chip_number_id, data.message);
        }

        if (data?.type == 'status') {
          if (data.chip_number_id && data.message) this.updateStatus(data.chip_number_id, data.message);
        }
      });
    },

    getDestinationName(item) {
      if (item.redirect === 'ai_chatbot') {
        const chatbot = this.chatbots.find(x => x._id.toString() === item.chatbot.toString());
        return { type: 'chatbot', name: chatbot?.name || 'Não definido', icon: 'mdi-robot-outline' };
      }

      if (item.redirect === 'flow_chatbot') {
        const flow = this.flows.find(x => x._id.toString() === item.flow.toString());
        return { type: 'flow', name: flow?.name || 'Não definido', icon: 'mdi-sitemap-outline' };
      }

      if (item.redirect === 'human') return { type: 'human', name: 'Atendimento humano', icon: 'mdi-face-agent' };
    },

    getDepartmentName(id) {
      const department = this.departments.find(x => x._id.toString() === id.toString());
      return department?.name || 'Não definido'
    },

    async editChip(item) {
      const selectedItem = JSON.parse(JSON.stringify(item));

      if (!selectedItem.inactivity_config) {
        selectedItem.inactivity_config = {
          enabled: selectedItem.inactivity_enabled || false,
          time: selectedItem.inactivity_time || 30,
          time_unit: selectedItem.inactivity_time_unit || 'minutes',
          context: selectedItem.inactivity_context || [],
          action: selectedItem.inactivity_action || null,
          flow: selectedItem.inactivity_flow || null,
          department: selectedItem.inactivity_department || null
        }
      }

      this.selectedItem = selectedItem;
    
      const originalFunnelStep = this.selectedItem.funnel_step;
      
      if (this.selectedItem.funnel) {
        await this.onFunnelChange();
        this.selectedItem.funnel_step = originalFunnelStep;
      }
      
      this.dialogChip = true;
    },

    async createOrUpdate() {
      if (this.selectedItem.name == "") return emitToastr("error", "Nome do número necessário");
      if (!this.selectedItem.redirect) return emitToastr("error", "Tipo do primeiro atendimento necessário");

      if (this.selectedItem.redirect == "ai_chatbot" && !this.selectedItem.chatbot) return emitToastr("error", "Chatbot necessário para este tipo de primeiro atendimento.");
      if (this.selectedItem.redirect == "flow_chatbot" && !this.selectedItem.flow) return emitToastr("error", "Chatbot de fluxo necessário para este tipo de primeiro atendimento.");
      if (!this.selectedItem.department) return emitToastr("error", "Departamento de entrada da conversa necessário");
      
      if (this.selectedItem.create_opportunity) {
        if (!this.selectedItem.funnel) return emitToastr("error", "Funil necessário quando criação de oportunidade está ativa");
        if (!this.selectedItem.funnel_step) return emitToastr("error", "Etapa do funil necessária quando criação de oportunidade está ativa");
      }

      if (this.selectedItem.inactivity_config.enabled) {
        if (!this.selectedItem.inactivity_config.context || this.selectedItem.inactivity_config.context.length === 0) return emitToastr("error", "Contexto da inatividade necessário quando ações de inatividade estão ativas");
        if (!this.selectedItem.inactivity_config.time || this.selectedItem.inactivity_config.time < 1) return emitToastr("error", "Tempo de inatividade deve ser maior que 0");
        if (this.selectedItem.inactivity_config.time_unit == 'hours' && this.selectedItem.inactivity_config.time > 168) return emitToastr("error", "Tempo de inatividade não pode ser maior que 168 horas (7 dias)");
        if (!this.selectedItem.inactivity_config.action) return emitToastr("error", "Ação de inatividade necessária quando ações de inatividade estão ativas");
        if (this.selectedItem.inactivity_config.action === 'flow_chatbot' && !this.selectedItem.inactivity_config.flow) return emitToastr("error", "Fluxo de inatividade necessário quando a ação é transferir para fluxo");
        if (this.selectedItem.inactivity_config.action === 'human' && !this.selectedItem.inactivity_config.department) return emitToastr("error", "Departamento de inatividade necessário quando a ação é transferir para humano");
      }

      if (this.selectedItem._id) {
        this.updateChip();
        return;
      }

      const chip = {
        name: this.selectedItem.name.trim(),
        status: "new",
        chatbot: this.selectedItem.chatbot,
        flow: this.selectedItem.flow,
        redirect: this.selectedItem.redirect,
        department: this.selectedItem.department,
        official: this.selectedItem.official,
        active: false,
        create_opportunity: this.selectedItem.create_opportunity || false,
        funnel: this.selectedItem.funnel,
        funnel_step: this.selectedItem.funnel_step,
        inactivity_config: {
          ...this.selectedItem.inactivity_config,
          action: this.selectedItem.inactivity_config.action ?? 'finish_conversation'
        },
      }

      this.loading = true;
      const resp = await Api.createOrUpdateChipNumber(chip);
      this.loading = false;

      if (!resp.error) {
        emitToastr("success", "Número cadastrado com sucesso. Agora será necessário fazer a conexão.");
        this.getChips();
        this.dialogChip = false;

        if (chip.official && !chip.registered) {
          this.configChipId = resp.message?._id || null;
          this.dialogConfig = true;
          return;
        }
      }
    },

    updateStatus(chip_number_id, status) {
      this.chip_numbers.forEach(chip => {
        if (chip._id.toString() == chip_number_id.toString()) {
          chip.status = status;
          delete chip.qrcode;
          this.dialogQrCode = false;
        }
      })
    },

    updateQrcode(chip_number_id, qrcode) {
      this.chip_numbers.forEach(chip => {
        if (chip._id.toString() == chip_number_id.toString()) {
          this.qrcode_chip = JSON.parse(JSON.stringify(chip));
          this.qrcode_chip.qrcode = qrcode;
          this.dialogQrCode = true;
          this.$forceUpdate();
        }
      })
    },

    async connectChip(chip) {
      if (chip.official && !chip.registered) {
        this.configChipId = chip._id;
        this.dialogConfig = true;
        return;
      }

      await Api.connectChipNumber(chip, true);

      if (chip.official) {
        this.loading = true;

        setTimeout(() => {
          window.location.reload()
        }, 1500);
      }
    },

    goToSignup(routeName) {
      this.dialogConfig = false;
      this.$router.push({ name: routeName, query: this.configChipId ? { chip: this.configChipId } : {} });
    },

    callSupport() {
      window.open(`https://api.whatsapp.com/send?phone=5518981240097&text=Preciso falar com um humano`, "_blank");
    },

    async updateChip() {
      const resp = await Api.changeChipNumberChatbot(this.selectedItem);

      if (resp.error) {
        emitToastr("error", resp.message);
      }
      else {
        emitToastr("success", "Canal atualizado com sucesso");
        this.dialogChip = false;
        this.getChips();
      }
    },

    async disconnectChip(chip) {
      await Api.connectChipNumber(chip, false);

      if (chip.official) {
        this.loading = true;

        setTimeout(() => {
          window.location.reload()
        }, 1500);
      }
    },

    async resetCreds(chip) {
      chip.reset = true;
      const resp = await Api.createOrUpdateChipNumber(chip);
      if (!resp.error) emitToastr("success", "Atualizado com sucesso!")

      this.getChips();
      this.selectedItem = { redirect: 'ai_chatbot' };
    },

    formatText() {
      let text = this.selectedItem.name;
      if (!text) return;

      text = text.normalize("NFD").replace(/[\u0300-\u036f]/g, "");
      text = text.replace(/[^a-zA-Z0-9 ]/g, "");

      this.selectedItem.name = text;
    },

    async changeChatbot(item) {
      item.changed = true;
      this.$forceUpdate();
    }
  },
};
</script>

<style scoped>
.connection-option {
  height: 100%;
  padding: 16px;
  border: 2px solid var(--v-gray200-base);
  border-radius: 12px;
  cursor: pointer;
  transition: border-color 0.2s, transform 0.2s;
}

.connection-option:hover,
.connection-option:focus-visible {
  border-color: var(--v-primary-base);
  outline: none;
}

.connection-option-title {
  font-size: 18px;
  font-weight: 700;
}

.connection-option-subtitle {
  font-size: 14px;
}

.connection-option-requirement {
  margin-top: 12px;
  padding-top: 8px;
  border-top: 1px dashed var(--v-gray200-base);
}
</style>